"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_UNIX_TIME = exports.MS_REFRESH_TOKEN_BEFORE_EXPIRY = exports.PUBLIC_ACCESS_TOKEN_PAYLOAD = exports.DEFAULT_MOCKING_VALUES = exports.IDP_ACCESS_TOKEN_ENDPOINT = exports.LOCAL_STORAGE_JWT_EXPIRY = exports.LOCAL_STORAGE_JWT = exports.LOCAL_STORAGE_JWT_TOKEN = exports.SIGN_OPTIONS = void 0;
// Options structure to be found here https://www.npmjs.com/package/jsonwebtoken
exports.SIGN_OPTIONS = {
    issuer: 'Bynder',
    subject: 'someone@bynder.com',
    audience: 'bynder.com',
    expiresIn: '12h',
    algorithm: 'RS256',
};
exports.LOCAL_STORAGE_JWT_TOKEN = 'jwt_access_token';
exports.LOCAL_STORAGE_JWT = 'jwt';
exports.LOCAL_STORAGE_JWT_EXPIRY = 'jwt_expiry';
exports.IDP_ACCESS_TOKEN_ENDPOINT = '/v7/idp/access-tokens/by-session';
exports.DEFAULT_MOCKING_VALUES = {
    ACCOUNT_ID: 'b05f9df8-cd3b-4b30-b57b-5b45ffaac62f',
    PROFILE_ID: '03cedc27-8755-4849-8b26-3e41e2709a21',
    USER_ID: 'ab851f80-916b-4e12-a49c-b70e6ab1f817',
};
exports.PUBLIC_ACCESS_TOKEN_PAYLOAD = {
    accountId: '',
    userId: '',
    profileId: '',
    groupIds: [],
    modulePermissions: [],
};
exports.MS_REFRESH_TOKEN_BEFORE_EXPIRY = 5 * 60 * 1000; // 5 minutes
exports.MAX_UNIX_TIME = 9999999999999;
//# sourceMappingURL=index.js.map